module.exports = __webpack_public_path__ + "img/working.d61b5ed7.png";